import React, { useEffect, useState } from "react";
import { CountryLoadingDialog } from "./country-loading-dialog/CountryLoadingDialog";
import { CountryCard } from "./CountryCard";
import { CountryUIProvider } from "./CountryUIContext";
import { CountryDeleteModal } from "./country-delete-modal/CountryDeleteModal";
import { CountryEditModal } from "./country-edit-modal/CountryEditModal";
import UpdatedSuccessfulModal from "../Modal/UpdatedSuccessfulModal";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import {
  addCountryApi,
  countryListApi,
  deleteCountryApi,
  editCountryApi,
} from "../../../axios/services/services";
import ErrorModal from "../Modal/ErrorModal";
import { useFormik } from "formik";
import {
  AddCountrySchema,
  EditCountrySchema,
} from "../../FormikSchema/FormikSchema";
import AddCountryModal from "../Modal/AddCountryModal";
import { capitalizeFirstLetter, isUnauthorized, trimmer } from "../../utils/utils";
import { initialFilter } from "./CountryUIHelpers";

const EditCountryInitialValues = {
  name: "",
  country_code: "",
  status: "",
};

const AddCountryInitialValues = {
  name: "",
  country_code: "",
  status: "1",
};

export function CountryPage({ history }) {
  const [isLoading, setLoading] = useState(false);
  const [isLoadingAddNewCountry, setLoadingAddNewCountry] = useState(false);
  const [isLoadingEditCountry, setLoadingEditCountry] = useState(false);
  const [isLoadingDeleteCountry, setLoadingDeleteCountry] = useState(false);

  const [isConfirmModal, setConfirmModal] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [isEditModal, setEditModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [data, setData] = useState({});
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [countryList, setCountryList] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [countryListTotalCount, setCountryListTotalCount] = useState(0);
  const [isAddCountryModal, setAddCountryModal] = useState(false);
  const [filterValues, setFilterValues] = useState({});
  const [isUpdateCountryList, setUpdateCountryList] = useState(0);
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);

  const countryUIEvents = {
    openReceiptDialog: (row) => {
      setData(row);
      handleConfirmShow();
    },
    openDeleteDialog: (row) => {
      setData(row);
      handleDeleteShow();
    },
    openEditDialog: (row) => {
      setData(row);
      const { name, country_code, status } = row;
      formikEditCountry.setFieldValue("name", name);
      formikEditCountry.setFieldValue("country_code", country_code);
      formikEditCountry.setFieldValue("status", status ? "1" : "0");
      handleEditShow();
    },
  };

  useEffect(() => {
    async function getCountryList() {
      enableLoading();
      const countryListResponse = await countryListApi({
        filterValues,
        queryParams,
        isActiveOnly: 0,
      });
      disableLoading();
      if (countryListResponse.Error) {
        isUnauthorized({ response: countryListResponse });
        setErrorMessage(countryListResponse.Error.message);
        handleErrorModalShow();
        return;
      }
      setCountryListTotalCount(
        countryListResponse && countryListResponse.count
          ? countryListResponse.count
          : 0
      );
      setCountryList(
        countryListResponse && countryListResponse.data
          ? countryListResponse.data
          : []
      );
    }
    getCountryList();
  }, [filterValues, isUpdateCountryList, queryParams]);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const enableLoadingAddCountry = () => {
    setLoadingAddNewCountry(true);
  };

  const disableLoadingAddCountry = () => {
    setLoadingAddNewCountry(false);
  };

  const enableLoadingEditCountry = () => {
    setLoadingEditCountry(true);
  };

  const disableLoadingEditCountry = () => {
    setLoadingEditCountry(false);
  };

  const enableLoadingDeleteCountry = () => {
    setLoadingDeleteCountry(true);
  };

  const disableLoadingDeleteCountry = () => {
    setLoadingDeleteCountry(false);
  };

  const handleConfirmShow = () => {
    setConfirmModal(true);
  };

  const handleConfirmHide = () => {
    setConfirmModal(false);
  };

  const handleDeleteShow = () => {
    setDeleteModal(true);
  };

  const handleDeleteHide = () => {
    setDeleteModal(false);
  };

  const handleEditShow = () => {
    setEditModal(true);
  };

  const handleEditHide = () => {
    setEditModal(false);
  };

  const handleSuccessModalShow = () => {
    setIsSuccessModalOpen(true);
  };

  const handleSuccessModalHide = () => {
    setIsSuccessModalOpen(false);
  };

  const handleErrorModalShow = () => {
    setIsErrorModalOpen(true);
  };

  const handleErrorModalHide = () => {
    setIsErrorModalOpen(false);
  };

  const handleAddCountryShow = () => {
    setAddCountryModal(true);
  };

  const handleAddCountryHide = () => {
    setAddCountryModal(false);
  };

  const handleFilterValues = (values) => {
    setFilterValues(values);
  };

  const formikAddCountry = useFormik({
    initialValues: AddCountryInitialValues,
    validationSchema: AddCountrySchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      addCountry(values, setSubmitting);
    },
    onReset: (values, { resetForm }) => {},
  });

  const formikEditCountry = useFormik({
    initialValues: EditCountryInitialValues,
    validationSchema: EditCountrySchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      editCountry(values, setSubmitting);
    },
    onReset: (values, { resetForm }) => {},
  });

  const handleOnClickOfAddCancelButton = () => {
    formikAddCountry.handleReset();
    disableLoadingAddCountry();
    handleAddCountryHide();
  };

  const handleOnClickOfEditCancelButton = () => {
    formikEditCountry.handleReset();
    disableLoadingAddCountry();
    handleEditHide();
  };

  const onClickOfCancelButton = () => {
    disableLoadingDeleteCountry()
    handleDeleteHide()
  };
  
  const handleSetCurrentPage = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const addCountry = async (values, setSubmitting) => {
    const { name, country_code, status } = values;
    let addCountryObj = {
      name,
      country_code,
      status: parseInt(status) === 1 ? true : false,
    };
    enableLoadingAddCountry();
    const addCountryResponse = await addCountryApi(trimmer(addCountryObj));
    disableLoadingAddCountry();
    setSubmitting(false);
    if (addCountryResponse.Error) {
      isUnauthorized({ response: addCountryResponse });
      setErrorMessage(addCountryResponse.Error.message);
      handleErrorModalShow();
      return;
    }
    setSuccessMessage("Country Added Successfully");
    formikAddCountry.setFieldValue("name", "");
    formikAddCountry.setFieldValue("country_code", "");
    setUpdateCountryList(Math.random());
    handleSuccessModalShow();
    handleAddCountryHide();
  };

  const editCountry = async (values, setSubmitting) => {
    const { id } = data;
    const { name, country_code, status } = values;
    let editCountryObj = {
      id,
      name,
      country_code,
      status: parseInt(status) === 1 ? true : false,
    };
    enableLoadingEditCountry();
    const editCountryResponse = await editCountryApi(trimmer(editCountryObj));
    disableLoadingEditCountry();
    setSubmitting(false);
    if (editCountryResponse.Error) {
      isUnauthorized({ response: editCountryResponse });
      setErrorMessage(editCountryResponse.Error.message);
      handleErrorModalShow();
      return;
    }
    setSuccessMessage("Country Edited Successfully");
    handleSuccessModalShow();
    handleEditHide();
    setUpdateCountryList(Math.random());
  };

  const handleDeleteCountry = () => {
    deleteCountry();
  };

  const deleteCountry = async () => {
    const { id, name } = data;
    enableLoadingDeleteCountry();
    const deleteCountryResponse = await deleteCountryApi({ id });
    disableLoadingDeleteCountry();
    const { Error } = deleteCountryResponse || {};
    if (Error) {
      const { message } = Error || {};
      isUnauthorized({ response: deleteCountryResponse });
      setErrorMessage(message);
      handleErrorModalShow();
      return;
    }
    const countryName = capitalizeFirstLetter(name);
    setSuccessMessage(`${countryName} Country Deleted Successfully`);
    setUpdateCountryList(Math.random());
    handleSuccessModalShow();
    handleDeleteHide();
  };

  return (
    <CountryUIProvider
      countryUIEvents={countryUIEvents}
      queryParams={queryParams}
      setQueryParamsBase={setQueryParamsBase}
      ids={ids}
      setIds={setIds}
    >
      <CountryLoadingDialog />

      {isAddCountryModal && (
        <AddCountryModal
          isLoadingAddNewCountry={isLoadingAddNewCountry}
          isAddCountryModal={isAddCountryModal}
          handleAddCountryHide={handleAddCountryHide}
          formik={formikAddCountry}
          onClickOfCancelButton={handleOnClickOfAddCancelButton}
        />
      )}

      {isDeleteModal && (
        <CountryDeleteModal
          isLoadingDeleteCountry={isLoadingDeleteCountry}
          data={data}
          onClickOfSaveButton={handleDeleteCountry}
          onClickOfCancelButton={onClickOfCancelButton}
          isDeleteModal={isDeleteModal}
        />
      )}

      {isEditModal && (
        <CountryEditModal
          isLoadingEditCountry={isLoadingEditCountry}
          formik={formikEditCountry}
          data={data}
          handleEditHide={handleEditHide}
          isEditModal={isEditModal}
          onClickOfCancelButton={handleOnClickOfEditCancelButton}
        />
      )}

      <CountryCard
        isLoading={isLoading}
        filterValues={filterValues}
        handleFilterValues={handleFilterValues}
        handleAddCountryShow={handleAddCountryShow}
        countryListTotalCount={countryListTotalCount}
        currentPage={currentPage}
        setCurrentPage={handleSetCurrentPage}
        // paginateCountryList={handlePaginateCountryList}
        countryList={countryList}
      />

      <UpdatedSuccessfulModal
        message={successMessage}
        UpdatedSuccessfulModalShow={isSuccessModalOpen}
        UpdatedSuccessfulModalHide={handleSuccessModalHide}
        successIcon={
          <div className="success-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
              />
            </span>
          </div>
        }
      />

      <ErrorModal
        message={errorMessage}
        isErrorModalOpen={isErrorModalOpen}
        hideErrorModal={handleErrorModalHide}
        errorIcon={
          <div className="danger-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
              />
            </span>
          </div>
        }
        errorButtonLabel={"Close"}
        errorOnClick={handleErrorModalHide}
      />
    </CountryUIProvider>
  );
}
